// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"qY-z","subtitle":"rY-z","wrapper":"sY-z","leftArrow":"tY-z","rightArrow":"uY-z"};